import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  }
};

function ButtonsZeroChecked({
  isFilter,
  handleFilterToggle,
  handleClickNazad
}) {
  const { dictionary } = useGlobalContext();

  return (
    <>
      <div style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["stampaj"]}
        </Button>
      </div>
      <div style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["posalji"]}
        </Button>
      </div>
      <div onClick={handleClickNazad} style={{ width: "25%" }}>
        <Button activation={true} style={styles.button}>
          {dictionary["nazad"]}
        </Button>
      </div>
      <div onClick={handleFilterToggle} style={{ width: "25%" }}>
        <Button active={isFilter} style={styles.button}>
          {dictionary["filtriraj"]}
        </Button>
      </div>
    </>
  );
}

export default ButtonsZeroChecked;
